module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/220.4f39cf61.png";